import { useState, useCallback, useEffect } from 'react'
import { useGeoRuntime } from '../geo/useGeoRuntime'
import { SupportedGeo } from '../geo/config'

export const useFormGeo = () => {
  const { geo, geoConfigByGeo } = useGeoRuntime()
  const [formGeo, setFormGeo] = useState<SupportedGeo>(geo)

  useEffect(() => {
    setFormGeo(geo)
  }, [geo])

  const handleFormGeoChange = useCallback((nextGeo: SupportedGeo) => {
    setFormGeo(nextGeo)
  }, [])

  const formGeoConfig = geoConfigByGeo(formGeo)

  return {
    formGeo,
    formGeoConfig,
    handleFormGeoChange,
  }
}
